var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},_vm._l((_vm.imgNum),function(i){return _c('img',{key:'bc-' + i,attrs:{"src":_vm.getImg(i)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }